import React from 'react';
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import Layout from "./Layout";
import AuthShell from '../../components/auth/AuthShell';
import { Head } from '../../components/auth/parts';
import useAuthTitle from '../../components/auth/useAuthTitle';
import { hasVerifiedSession } from '../../utils/authSession';

const NotFound = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    useAuthTitle('nf');
    // Same signal the route guards use. (This used to read a legacy
    // `access_token` localStorage key that nothing has written since the token
    // moved to an httpOnly cookie, so the signed-in branch was dead code.)
    const isAuthenticated = hasVerifiedSession();

    if (isAuthenticated) {
        return (
            <Layout>
                <div className="text-center mt-5" >
                    <h2 className="mb-2 mx-2">{t('nav.not_found_title')}</h2>
                    <p className="mb-4 mx-2">{t('nav.not_found_message')}</p>
                </div>
            </Layout >
        );
    }

    return (
        <AuthShell>
            <div className="ppa-big">404</div>
            <Head title={t('authPage.nf.h')} text={t('authPage.nf.p')} />
            <button className="ppa-btn" type="button" onClick={() => navigate('/login')}>{t('authPage.nf.btn')}</button>
        </AuthShell>
    );
};

export default NotFound;
